import { Description } from '@zenterprise-inc/ui';
import { FC, useEffect, useRef, useState } from 'react';

import { BusinessType } from '@/lib/types/request';

const guideContents = [
  {
    subTitle: '환급 조회 대기 중…',
    description: '환급 조회를 시작하면 \n보통 30초 안에 완료돼요.',
    descriptionWithPhone: '환급 조회를 시작하면 \n보통 30초 안에 완료돼요.',
    indisTimeout: 0,
    corpsTimeout: 0
  },
  {
    subTitle: '세금 신고 내역 수집 중...',
    description: '보통 30초 안에 완료돼요.\n잠시만 기다려주세요.',
    descriptionWithPhone: '보통 30초 안에 완료돼요.\n잠시만 기다려주세요.',
    indisTimeout: 15000,
    corpsTimeout: 20000
  },
  {
    subTitle: '환급 가능 여부 분석 중...',
    description: '보통 30초 안에 완료돼요.\n잠시만 기다려주세요.',
    descriptionWithPhone: '보통 30초 안에 완료돼요.\n잠시만 기다려주세요.',
    indisTimeout: 15000,
    corpsTimeout: 20000
  },
  {
    subTitle: '5년치 환급액 계산 중...',
    description: '보통 30초 안에 완료돼요.\n잠시만 기다려주세요.',
    descriptionWithPhone: '보통 30초 안에 완료돼요.\n잠시만 기다려주세요.',
    indisTimeout: 30000,
    corpsTimeout: 50000
  },
  {
    subTitle: '앗, 추가 자료를 발견했어요',
    description: '자료가 많아 시간이 더 소요되고 있어요.\n잠시만 기다려주세요.',
    descriptionWithPhone: '자료가 많아 시간이 더 소요되고 있어요.\n잠시만 기다려주세요.',
    indisTimeout: 60000,
    corpsTimeout: 30000
  },
  {
    subTitle: '추가 자료 반영 중...',
    description: '자료가 많아 시간이 더 소요되고 있어요.\n잠시만 기다려주세요.',
    descriptionWithPhone: '자료가 많아 시간이 더 소요되고 있어요.\n잠시만 기다려주세요.',
    indisTimeout: 60000,
    corpsTimeout: 60000
  },
  {
    subTitle: '최종 환급액 계산 중...',
    description: '자료가 많아 시간이 더 소요되고 있어요.\n조금만 더 기다려주세요.',
    descriptionWithPhone: '화면을 닫아도 괜찮아요.\n환급액이 있다면 알림톡으로 알려드릴게요.'
  }
];

const guideComplete = {
  subTitle: '마지막 확인 중...',
  description: '거의 다 되었어요.\n곧 예상 환급액 계산이 완료돼요.'
};

interface Props {
  businessType: BusinessType;
  isStarted: boolean;
  hasPhoneNumber: boolean;
  isLastStep: boolean;
}
type GuideChangerProps = Props;

const GuideChanger: FC<GuideChangerProps> = ({ businessType, isStarted, hasPhoneNumber, isLastStep }) => {
  const [subTitle, setSubTitle] = useState(guideContents[0]?.subTitle);
  const [description, setDescription] = useState(guideContents[0]?.description);

  const timeoutId = useRef<ReturnType<typeof setInterval> | null>(null);
  const guideIndex = useRef(0);

  const handleTimeout = () => {
    const index = guideIndex.current + 1;
    setSubTitle(guideContents[index]?.subTitle);
    if (hasPhoneNumber) {
      setDescription(guideContents[index]?.descriptionWithPhone);
    } else {
      setDescription(guideContents[index]?.description);
    }
    guideIndex.current = index;

    if (index < guideContents.length - 1) {
      switch (businessType) {
        case 'indis':
          timeoutId.current = setTimeout(handleTimeout, guideContents[index]?.indisTimeout);
          break;

        default:
          timeoutId.current = setTimeout(handleTimeout, guideContents[index]?.corpsTimeout);
          break;
      }
    }
  };

  useEffect(() => {
    if (!isStarted) return;

    switch (businessType) {
      case 'indis':
        timeoutId.current = setTimeout(handleTimeout, guideContents[0]?.indisTimeout);
        break;

      default:
        timeoutId.current = setTimeout(handleTimeout, guideContents[0]?.corpsTimeout);
        break;
    }

    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, [isStarted]);

  return (
    <>
      <Description>
        {isLastStep ? (
          <Description.Guide subTitle={guideComplete.subTitle} description={guideComplete.description} />
        ) : (
          <Description.Guide subTitle={subTitle} description={description} />
        )}
      </Description>
    </>
  );
};

export default GuideChanger;
